import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import cc from 'classcat';
import PropTypes from 'prop-types';
import EverGreen from '../EverGreen';
import Image from '../Image';
import css from './Card.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Card = function Card(_ref) {
  var icon = _ref.icon,
      evergreen = _ref.evergreen,
      id = _ref.id,
      url = _ref.url,
      title = _ref.title,
      image = _ref.image,
      description = _ref.description,
      other = _ref.other;
  return /*#__PURE__*/_jsxs("li", {
    className: cc([css.item, _defineProperty({}, css.other, other)]),
    id: "fabric-".concat(id),
    children: [/*#__PURE__*/_jsx("a", {
      className: css.itemLink,
      href: "".concat(url, "?fabric=").concat(id),
      "aria-label": "Learn more about ".concat(title, " fabric"),
      children: /*#__PURE__*/_jsx("div", {
        className: css.fabric,
        children: /*#__PURE__*/_jsx("div", {
          className: css.imgWrap,
          children: /*#__PURE__*/_jsx("div", {
            className: css.img,
            children: /*#__PURE__*/_jsx(Image, _objectSpread(_objectSpread({}, image), {}, {
              alt: title,
              sizes: [400, 500]
            }))
          })
        })
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: css.content,
      children: [/*#__PURE__*/_jsx("div", {
        className: css.title,
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: css.description,
        children: description
      }), (icon === null || icon === void 0 ? void 0 : icon.svg) && /*#__PURE__*/_jsx("div", {
        className: css.circle,
        children: /*#__PURE__*/_jsx("div", {
          "aria-hidden": "true",
          className: css.icon,
          dangerouslySetInnerHTML: {
            __html: icon.svg
          },
          role: "presentation"
        })
      }), evergreen && /*#__PURE__*/_jsx(EverGreen, {
        small: true
      })]
    })]
  });
};

Card.defaultProps = {
  icon: null,
  other: false
};
Card.propTypes = {
  evergreen: PropTypes.bool.isRequired,
  icon: PropTypes.shape(),
  id: PropTypes.string.isRequired,
  other: PropTypes.bool,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape().isRequired,
  description: PropTypes.string.isRequired
};
export default Card;